import { compose, setDisplayName } from 'recompose';
import { modal } from 'ui/shared/modal';
import { ChangeImageForm, OwnProps } from './ChangeImageForm';

import './ChangeImageDialog.css';

export const ChangeImageDialog = compose<OwnProps, OwnProps>(
    setDisplayName('ChangeImageDialog'),
    modal('change-image-dialog'),
)(ChangeImageForm);



// WEBPACK FOOTER //
// ./src/ui/pages/changeImage/ChangeImageDialog.tsx